// extracted by mini-css-extract-plugin
export default {"formLabel":"kpiReport_formLabel__GYBW+"};